import React from 'react';
import { Form, Input } from 'antd';

const PersonalInfo = ({ personalInfo, setPersonalInfo, setShippingAddress }) => {
  // Handle input change and update state
  const handleChange = (field, value) => {
    setPersonalInfo(prev => {
      const updated = { ...prev, [field]: value };

      // Keep shipping address in sync when address fields are updated
      if (
        ["address1", "address2", "city", "zip"].includes(field)
      ) {
        setShippingAddress({
          addressLine1: updated.address1 || "",
          addressLine2: updated.address2 || "",
          city: updated.city || "",
          postcode: updated.zip || "",
        });
      }

      return updated;
    });
  };

  return (
    <div className="step-content">
      <div className="step-cont-wrap">
        {/* <h3 className="step-title">Your Details</h3> */}
        <p className="step-description">
          Please enter your personal details (name, email, phone, date of birth) to verify your identity and provide safe, legal access to prescription medication. You'll then upload your prescription, add medication details, and complete payment. A UK-based prescription will be issued within 24 hours in line with healthcare regulations. Your information is kept secure and used only to process your request.
        </p>
      </div>
      <div className="row">
        <div className="col-lg-6 mb-10">
          <Form.Item
            label="Full Name"
            required
            rules={[{ required: true, message: "Please enter your full name" }]}
          >
            <Input
              placeholder="e.g. John Doe"
              value={personalInfo.name}
              onChange={e => handleChange("name", e.target.value)}
            />
          </Form.Item>
        </div>
        <div className="col-lg-6 mb-10">
          <Form.Item
            label="Email Address"
            required
            rules={[
              { required: true, message: "Please enter your email" },
              { type: 'email', message: "Please enter a valid email address" },
            ]}
          >
            <Input
              placeholder="e.g. john@example.com"
              value={personalInfo.email}
              onChange={e => handleChange("email", e.target.value)}
            />
          </Form.Item>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 mb-10">
          <Form.Item
            label="Phone Number"
            required
            rules={[{ required: true, message: "Please enter your phone number" }]}
          >
            <Input
              placeholder="e.g. +447123456789"
              value={personalInfo.phone}
              onChange={e => handleChange("phone", e.target.value)}
            />
          </Form.Item>
        </div>
        <div className="col-lg-6 mb-10">
          <Form.Item
            label="Date of Birth"
            required
            rules={[{ required: true, message: "Please enter your date of birth" }]}
          >
            <Input
              type="date"
              value={personalInfo.dob}
              onChange={e => handleChange("dob", e.target.value)}
            />
          </Form.Item>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 mb-10">
          <div className="row">
            <div className="col-lg-12">
              <h4 style={{ marginBottom: "20px" }}>Address</h4>
            </div>
            <div className="col-lg-12">
              <Form.Item
                className="mb-5"
                label="Address Line 1"
                required
                rules={[{ required: true, message: "Please enter address line 1" }]}
              >
                <Input
                  placeholder="e.g. 123 Main St"
                  value={personalInfo.addressLine1}
                  onChange={e => handleChange("address1", e.target.value)}
                />
              </Form.Item>

              <Form.Item className="mb-5" label="Address Line 2 (Optional)">
                <Input
                  placeholder="e.g. Apt 4B"
                  value={personalInfo.addressLine2}
                  onChange={e => handleChange("address2", e.target.value)}
                />
              </Form.Item>

              <div className="row">
                <div className="col-lg-6 mb-5">
                  <Form.Item
                    label="City"
                    required
                    rules={[{ required: true, message: "Please enter your city" }]}
                  >
                    <Input
                      placeholder="e.g. London"
                      value={personalInfo.city}
                      onChange={e => handleChange("city", e.target.value)}
                    />
                  </Form.Item>
                </div>
                <div className="col-lg-6 mb-5">
                  <Form.Item
                    label="Postcode"
                    required
                    rules={[{ required: true, message: "Please enter your postcode" }]}
                  >
                    <Input
                      placeholder="e.g. W1A 1AA"
                      value={personalInfo.postcode}
                      onChange={e => handleChange("zip", e.target.value)}
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
